import React from 'react';
import { StyleSheet } from 'react-native';

import { ModalBackdrop, theme } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { HorizontalSafeAreaContainer, NotFoundView, SierraHostedFrame } from '../../components';
import { useNavigateBack } from '../../navigation';

export const ChatScreen = () => {
  const isSierraEnabled = useFeatureFlag('permanent-sierra-enabled');

  if (!isSierraEnabled) return <NotFoundView />;

  return <SierraChatScreen />;
};

const SierraChatScreen = () => {
  const navigateBack = useNavigateBack();

  return (
    <HorizontalSafeAreaContainer style={styles.safeAreaContainer}>
      <SierraHostedFrame onClose={navigateBack} />
      <ModalBackdrop onPress={navigateBack} />
    </HorizontalSafeAreaContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  safeAreaContainer: {
    backgroundColor: theme.colors.LIME,
  },
});
